import { render, staticRenderFns } from "./oilStation.vue?vue&type=template&id=6a088f35&scoped=true&"
import script from "./oilStation.vue?vue&type=script&lang=js&"
export * from "./oilStation.vue?vue&type=script&lang=js&"
import style0 from "./oilStation.vue?vue&type=style&index=0&id=6a088f35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a088f35",
  null
  
)

export default component.exports